module.exports = __webpack_public_path__ + "img/10.450b203c.jpg";